// extracted by mini-css-extract-plugin
export default {"header":"_7eMh8","column":"BYIxXN","title":"DS1H7n","centerAligned":"TnAcpK","smallText":"r8JNdn","searchFadeIn":"hxZvdD"};